import store from '@/store'; // Import the store, not state

function formatPaymentType(value) {
  // eslint-disable-next-line import/no-named-as-default-member
  const paymentTypes = (store.state.enums || {}).TaxPaymentEnum || [];
  const paymentTypeIndex = paymentTypes.findIndex((type) => type.name === value);
  // Return the number (index + 1) like in TaxEditDialog, fallback to original value
  return paymentTypeIndex !== -1 ? (paymentTypeIndex + 1).toString() : value;
}

const largePaymentHeaders = [
  {
    text: 'Type',
    value: 'taxType',
    formatter: 'customMethod',
    methodDefinition: formatPaymentType,
    sortable: false,
  },
  {
    text: 'Year',
    value: 'taxYear',
    sortable: false,
  },
  {
    text: 'Tax ID',
    value: 'taxId',
    sortable: false,
  },
  {
    text: 'Owner Name',
    value: 'ownerName',
    sortable: false,
  },
  {
    text: 'Tax Type',
    value: 'propertyTaxType',
    formatter: 'propertyTaxTypeShortCode',
    sortable: false,
    // .tax-type-col adds padding-left, and in Vuetify 2 `class` reaches the header th ONLY -
    // the body td needs cellClass (CRUDRow applies it). With just `class` the heading shifted
    // right by 32px while the RE/PP value stayed put, so the two did not line up. Vue 3 sets
    // both via headerProps/cellProps, which is why it looked correct there.
    class: 'tax-type-col',
    cellClass: 'tax-type-col',
  },
  {
    // Shares its slot with Cert No - LargePaymentList.buildHeaders() rewrites this entry to
    // certNumber when showCertNumberOnPaymentScreen is on. That swap keys off value ===
    // 'reciept', so dropping this header silently turned the swap into a no-op rather than
    // breaking anything loudly.
    text: 'Receipt',
    value: 'reciept',
    sortable: false,
  },
  {
    text: 'Tax Amt to Pay',
    value: 'taxAmt',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Penalty Amt',
    value: 'penaltyAmt',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'fees Total',
    value: 'totalFees',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Total Pay',
    value: 'total',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Posted',
    value: 'posted',
    align: 'center',
    sortable: false,
    formatter: 'flagToYorEmpty',
  },
  {
    text: 'Protest',
    value: 'protest',
    align: 'center',
    sortable: false,
    formatter: 'flagToYorEmpty',
  },
];
export default largePaymentHeaders;
